<template>
  <div class="chart-of-accounts responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader
        :pageHeader="listPageHeader"
        :links="[
          { name: 'home', label: 'Home' },
          { name: 'chartOfAccounts', label: 'Chart of Account' },
        ]"
        :entity="entity"
      />
      <SearchTable :entity="entity" :sort="sort" @sortChangeEvent="updateSort"
        :pagination="pagination" @paginationChange="updatePagination" @initialFilterUpdate="updateInitialFilter"
        :initialFilter="initialFilter" />
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import { listPageHeader } from "./inputs";
import SearchTable from "@/components/SearchTable.vue";
import Entities from "@/resources/Entities";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "chartOfAccount",
  data() {
    return {
      listPageHeader,
      entity: Entities.CHARTOFACCOUNT,
    };
  },
  mounted: function () {
    this.setPageTitle("ChartOfAccount");
  },
  components: {
    PageHeader,
    SearchTable,
  },
  computed: {
    ...mapGetters({
      sort: "chartOfAccountModule/sort",
      pagination: "chartOfAccountModule/pagination",
      initialFilter: "chartOfAccountModule/initialFilter"
    }),
  },
  methods: {
    ...mapActions({
      updateSort: "chartOfAccountModule/updateSort",
      updatePagination: "chartOfAccountModule/updatePagination",
      updateInitialFilter: "chartOfAccountModule/updateInitialFilter"
    }),
  }
};
</script>
